import { ComposeTarget } from 'owa-mail-compose-store';
import isDeepLink from 'owa-popout/lib/utils/isDeepLink';
import isSxSDisplayed from 'owa-sxs-store/lib/utils/isSxSDisplayed';

export default function getComposeTarget(): ComposeTarget {
    const openInSxS = isSxSDisplayed();
    const openInTab = !isDeepLink();

    return openInSxS
        ? ComposeTarget.SxS
        : openInTab
        ? ComposeTarget.SecondaryTab
        : ComposeTarget.PrimaryReadingPane;
}
